import React, {useEffect, useState} from 'react'
import { Row, Col, Tabs, Card, Button} from 'antd'
import TransferBanks from './components/TransferBanks'
import CurrencyExchange from './components/CurrencyExchange'
import TransferDomestic from './components/TransferDomestic'
import TemplatePage from '../Templates/index'
import MassTransfers from 'pages/MassTransfers'
import AniPay from './components/AniPay'
import ForeignCurrency from './components/ForeignCurrency'
import GPP from './components/GPP'
import noSelected from '../../../assets/images/noSelectedTransfer.svg'

import { connect } from 'react-redux'

import './transfer.scss'
import {useHistory, useLocation} from "react-router-dom";
import {getPathnameByIndex} from "../../services/helper";
import GoBack from "components/goBack";
import {checkAnyPermission} from "../../services/permission";
import {getCurrentCompany} from "../../services/user";
import { useTranslation } from 'react-i18next'
import i18next from "../../../i18n";



const TransferPage: React.FC<any> = ({ leftMenuStatus, companyData }) => {
  const {t} = useTranslation();
  const Location=useLocation()
  const [visible,setVisible] = useState(true)
  const handleVisible=(e:any)=>{
    setVisible(e)
  }

  useEffect(() => {
   if(Location.pathname==='/new_transfer/gpp') {
     setVisible(true)
   }
  }, [Location]);



  const tabData: Array<any> = [
    {
      index: 1,
      name: t("home.internal"),
      content: <TransferBanks />,
      path : '/new_transfer/inside_bank',
      permissionKeys : ['OWN_ACCOUNT', 'INTERNAL']
    },
    {
      index: 2,
      name: t("home.currencyExchange"),
      content: <CurrencyExchange />,
      path : '/new_transfer/currency_exchange',
      permissionKeys : ['EXCHANGE']
    },
    {
      index: 3,
      name: t("home.domesticAZN"),
      content: <TransferDomestic />,
      path : '/new_transfer/domestic',
      permissionKeys : ['AZIPS', 'XOHKS', 'DXA', 'EDV']
    },
    {
      index: 4,
      name: <div >
        {/*<div className="oldword"  style={{display:"flex"}} >*/}
        <span >AniPay</span>
        {/*<div className='newword4'  style={{left:65}}>*/}
        {/*  <span className={Location.pathname.includes('/new_transfer/anipay')?"newword1":'reddot'}>*/}
        {/*    {Location.pathname.includes('/new_transfer/anipay')?"new":''}</span></div>*/}
      {/*</div> */}
    </div> ,
      content: <AniPay />,
      path : '/new_transfer/anipay',
      permissionKeys : ['IPS_OTH', 'IPS_BDG', 'IPS_VAT']
    },
    {
      index: 5,
      name: t("home.foreignCurrency"),
      content: <ForeignCurrency />,
      path : '/new_transfer/foreign_currency',
      permissionKeys : ['SWIFT', 'SWIFT_RUB']
    },
    {
      index:6,
      name:
          // <div className="oldword" onClick={()=>{setVisible(true)}} style={{display:"flex"}} >
        <span > {i18next.t('transfers.gpp')} </span>,
        // <div  className='newword4' style={{left:50}}> <span className={Location.pathname==='/new_transfer/gpp'?"newword1":'reddot'}>{Location.pathname==='/new_transfer/gpp'?"new":''}</span> </div>
      // </div>,
      content:<GPP visible={visible}

                   handleVisible={handleVisible}
      />,
      path: '/new_transfer/gpp',
      permissionKeys: ['GPP']
    },
    {
      index: 8,
      name: 
        <div
          className="oldword"
          onClick={() => { setVisible(true) }}
          style={{ display: "flex" }}
        > <span>{i18next.t("transfers.batchtransferswithoutsource")} </span>
          <div
            className='newword4 '
            style={{ right: -10 }}
          > <span ></span>
          </div>
      </div>,
      content: <MassTransfers />,
      path : '/new_transfer/mass_transfers',
      permissionKeys : ['BATCH_PAYMENT'],
    },
    {
      index: 7,
      name: t("home.templates"),
      content: <TemplatePage />,
      path : '/new_transfer/templates',
      permissionKeys : ['TEMPLATE']
    },
  ]
  
  const { TabPane } = Tabs;
  const history = useHistory();
  const location = useLocation();
  const find_tab=tabData.find(row => row.path===`/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`);
  const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);


  useEffect(() => {
    const find_tab=tabData.find(row => row.path===`/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`);

    setTabActiveKey(find_tab?.index);

  }, [location, companyData])

  const tabOnChange = (activeKey) => {
    setTabActiveKey(old_key => activeKey);

    const find_row=tabData.find(row => row.index==activeKey);

    history.push(find_row.path);
  };


  return (
      <>
        <Row>

          <Col span={24} className="transfer">

            <GoBack title={ tabActiveKey !== 7 ? t("home.newTransfer") : t("home.templates")} />

            <Tabs
                type="card"
                className={`tab_background transfer_parent_tab_main transfer_parent_tab_${tabActiveKey}`}
                activeKey={`${tabActiveKey}`}
                onChange={tabOnChange}
                destroyInactiveTabPane={true}

            >



              {tabData?.map((item, index) => {
                    return checkAnyPermission(item.permissionKeys) && (
                        <TabPane
                            className={`transfer_child_tabs`}
                            tab={item.name}
                            key={item.index}
                            style={{borderRadius:10}}
                        >
                          {getPathnameByIndex(1) && item.content}
                        </TabPane>
                    )
                  })}
            </Tabs>
          </Col>

            { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
              <img src={noSelected}/>
              </span> }

        </Row>
      </>
  )
}
const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
  companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany()
})
export default connect(mapStateToProps, null)(TransferPage)
